import { option, record, task, taskOption } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { taskRun } from '../internal/prelude.js';
import { makeLogger } from './logger.js';
import { extractSourceMappingUrl, withMappedStackTrace } from './mapStackTrace.js';
export * from '../sanitize.js';
export * from '../utils.js';
/**
 * Creates a logger instance that can be used in browsers.
 *
 * The "publish" function can be used for sending logs to a server, if needed.
 */
export const makeClientLogger = (publish) => {
    const sourceMapCache = {};
    const httpFetchSourceMap = (uri) => pipe(sourceMapCache, record.lookup(uri), option.match(() => pipe(taskOption.tryCatch(() => fetch(uri).then((r) => r.text())), taskOption.chainOptionK(extractSourceMappingUrl(uri)), taskOption.chain((url) => taskOption.tryCatch(() => fetch(url).then((r) => r.text()))), task.chainFirstIOK((map) => () => {
        sourceMapCache[uri] = map;
    })), task.of));
    const mapStackTraces = (x) => async () => {
        if (Array.isArray(x))
            await taskRun(task.traverseArray(mapStackTraces)(x));
        if (x instanceof Error)
            await taskRun(withMappedStackTrace(x, httpFetchSourceMap));
    };
    return makeLogger({ mapStackTraces, publish });
};
//# sourceMappingURL=index.js.map